/**
 * 计算字节内容的 SHA-256 十六进制摘要。
 *
 * 该工具位于中立 utils 层，供离线包与普通 sidecar 共同校验持久化内容身份，避免任一协议层
 * 反向依赖另一个具体容器实现。
 *
 * @param bytes 待摘要的原始字节。
 * @returns 64 位小写十六进制 SHA-256。
 * @throws 当运行环境未提供 `crypto.subtle` 时。
 */
export async function createSha256Hex(bytes: Uint8Array): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new Error('当前运行环境缺少 crypto.subtle，无法计算 SHA-256 摘要')
  }

  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes as BufferSource)
  return Array.from(new Uint8Array(digest))
    .map((value) => value.toString(16).padStart(2, '0'))
    .join('')
}
